module.exports = __webpack_public_path__ + "static/media/blockchain-icon.a6e50b24.png";